import React, {ReactNode} from "react";
import "./layout.scss";

interface Props {
    children: ReactNode,
    bgType?: 'home' | 'challenge' | 'tools' | 'team' | 'blog' | 'resources',
}

const Layout = ({
    children,
    bgType = 'home',
}: Props) => (
    <div className="contentContainer">
        <div
            className={['backgroundSvg', `bg-${bgType}`].join(' ')}
        >
            {children}
        </div>
    </div>
);

export default Layout;